import React from 'react';
import { Box, Typography } from '@mui/material';

export default function Footer() {
  const logoUrl = process.env.PUBLIC_URL + '/assets/branding/re-logo-square.png';

  return (
    <Box component="footer" sx={{ bgcolor: 'primary.main', color: 'white', p: 2, mt: 'auto', textAlign: 'center' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}>
        <img src={logoUrl} alt="Robinson Engineering logo" style={{ height: 24, marginRight: 8 }} />
        <Typography variant="body2">© {new Date().getFullYear()} Robinson Engineering</Typography>
      </Box>
    </Box>
  );
}
